/**
 * 运行时断言：协议边界和 store 内部用它收窄类型。
 * 失败即抛错——宁可早崩溃也不让坏数据流进 IndexedDB。
 */
export function invariant(condition: unknown, message: string): asserts condition {
  if (!condition) {
    throw new Error(`Invariant failed: ${message}`);
  }
}

/** 穷尽检查：switch 覆盖所有分支后 default 里调用，漏分支时编译期报错。 */
export function unreachable(value: never): never {
  throw new Error(`Unreachable: ${JSON.stringify(value)}`);
}
